import { TextField } from "@mui/material";
import React from "react";

type NumberFieldProps = {
  label: string;
  minDigits?: number;
  maxDigits?: number;
  onChange: (value: number | null) => void; // null when empty
  required: boolean;
  value: number | null; // allow null when field is empty
  width?: string | "200px";
};

export const NumberField: React.FC<NumberFieldProps> = ({ label, maxDigits, minDigits, onChange, required, value, width }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow only digits and limit length
    if (/^\d*$/.test(inputValue) && inputValue.length <= maxDigits) {
      if (inputValue === "") {
        onChange(null); // empty → null
      } else {
        onChange(Number(inputValue)); // valid number
      }
    }
  };

  return (
    <TextField
      label={label}
      variant="outlined"
      value={value ?? ""} // keep empty field editable
      onChange={handleChange}
      required={required}
      size="small"
      slotProps={{
        htmlInput: {
          inputMode: "numeric",
          pattern: `[0-9]*`,
          maxLength: maxDigits,
          minLength: minDigits,
        },
        inputLabel: {
          shrink: true,
        },
      }}
      sx={{ width: width }}
    />
  );
};
